<template>
    <div class="relative flex flex-col lg:flex-row">
        <div v-if="toc" class="lg:order-0 order-1 mb-4 px-[10px] lg:mb-0 lg:pr-8">
            <slot name="toc" :value="toc">
                <Toc2 :toc="toc" :active="activeHeader"></Toc2>
            </slot>
        </div>
        <div class="relative w-full flex-1 bg-white px-6 py-12 lg:pb-28 lg:pt-16" :class="{ 'shadow-xl shadow-slate-700/10 ring-1 ring-gray-900/5': shadow }">
            <article class="prose prose-slate mx-auto mt-8">
                <div v-if="intro_title || intro_desc">
                    <h2 v-if="intro_title" class="h2 mb-4 mt-0">
                        <span class="font-normal">{{ intro_title }}</span>
                    </h2>
                    <div v-if="intro_desc" v-html="intro_desc"></div>
                </div>
                <TocContent v-if="toc && toc.length > 0" :toc="toc" class="my-10"></TocContent>
                <div ref="docRef" v-html="content" />
            </article>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useDocHeaderActive } from "./active.core";
// import { useHashScollerChange } from "./useHashScoller";
import Toc2 from "./Toc2.vue";
import TocContent from "./TocContent.vue";

// useHashScollerChange();
withDefaults(defineProps<{ content: string; toc: any; shadow?: boolean; intro_desc?: string; intro_title?: string }>(), {
    shadow: true,
});
const docRef = ref<HTMLElement>();

const activeHeader = useDocHeaderActive(docRef as any);
// console.log("🚀 -> file: index.vue:23 -> activeHeader", activeHeader);
</script>

<style lang="scss">
.doc_render_toc {
    h2:target {
        padding-top: 100px;
    }
}
</style>
